// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditTrainerForm_R3An5hEBzQ7M83KT5IMU{width:500px}`, "",{"version":3,"sources":["webpack://./src/components/EditTrainerForm/EditTrainerForm.module.scss"],"names":[],"mappings":"AAAA,sCACE,WAAA","sourcesContent":[".EditTrainerForm {\n  width: 500px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"EditTrainerForm": `EditTrainerForm_R3An5hEBzQ7M83KT5IMU`
};
export default ___CSS_LOADER_EXPORT___;
